import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SystemStatusMessageDTO,
  SystemStatusMessageDTOMessageTypeEnum,
} from "../../generated/api";
import { GET_CURRENT_SYSTEM_STATUS_MESSAGES } from "../../redux/reducers/systemStatusMessageReducer";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export function SystemStatus() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const systemStatus = useSelector((store: any) => store.systemStatus);
  const settings = useSelector((store: any) => store.settings.internalSettings);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if(settings?.serverURL){
      dispatch({ type: GET_CURRENT_SYSTEM_STATUS_MESSAGES });
    }
  }, [dispatch, settings?.serverURL]);

  function getSeverity(messageType: SystemStatusMessageDTOMessageTypeEnum) {
    if (messageType === SystemStatusMessageDTOMessageTypeEnum.Info) {
      return "info";
    }
    if (messageType === SystemStatusMessageDTOMessageTypeEnum.Critical) {
      return "error";
    }
    if (messageType === SystemStatusMessageDTOMessageTypeEnum.Warning) {
      return "warning";
    }
  }

  

  return (
    <div>
      {systemStatus?.currentMessages?.length > 0 ? (
        <Box>
          <Stack>
            <Collapse in={open}>
              {systemStatus.currentMessages
                ? systemStatus?.currentMessages.map(
                    (statusMessage: SystemStatusMessageDTO, index: number) => (
                      <Alert
                        sx={{
                          "& .MuiAlert-message": {
                            width: "100%",
                          },
                        }}
                        key={index}
                        severity={getSeverity(statusMessage.messageType!)}
                      >
                        <Typography
                          sx={{ textAlign: "center" }}
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(statusMessage.message!),
                          }}
                        />
                      </Alert>
                    )
                  )
                : null}
            </Collapse>
            <IconButton
              color="primary"
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              <Typography>
                {open ? t("systemStatus.hideInfo") : t("systemStatus.showInfo")}
              </Typography>
            </IconButton>
          </Stack>
        </Box>
      ) : null}
    </div>
  );
}
